var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',[_c('p',{staticClass:"tittle-main-page text-center mt-11",staticStyle:{"color":"#001520"}},[_vm._v("\n                В процессе разработки\n            ")]),_vm._v(" "),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"#00599b"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }